import React, { Component }  from 'react'
import { connect } from 'react-redux'
import { dispatchActions as dispatchBundleActions } from 'components/bundle/bundleHandlerRedux'
import { dispatchActions as dispatchNodeActions } from 'components/node/nodeHandlerRedux'
import _ from 'lib/lodash'

import FileSelector from 'components/common/FileSelector'
import UploadProgress from 'components/common/UploadProgress'

import './PayloadContainer.css'

class PayloadContainer extends Component {
	state = {
		nodeType: null,
		scrollToItem: null,
	};

	/* { accept: "video/*" or "image/*" or ... } */
	selectFile = (nodeType, fileSelectOptions) => {
		this.fileSelector.fileUploadControl = Object.assign(this.fileSelector.fileUploadControl, fileSelectOptions);

		this.setState({ ...this.state, nodeType });
		this.fileSelector.onClick();
	};

	addNodeToPayload = (nodeType, node) => {
		const { payload } = this.props;

		this.setState({ ...this.state, nodeType });
		this.props.postNode(payload, nodeType, node, (newNode) => {
			this.setState({
				...this.state,
				scrollToItem: newNode.$id
			});
		});
	};

	addNodeAndFileToPayload = (file) => {
		const { nodeType } = this.state;
		const { payload } = this.props;

		let fileName = file.name.substr(0, file.name.lastIndexOf('.'));
		if (/^\d{11}__.{36}$/.test(fileName)) { // iOS video filename, e.g. 52822768057__75E7AE11-1F21-4D8E-8E33-ED4E0634A454
			const options = {
				year: "numeric", month: "short",
				day: "numeric", hour: "2-digit", minute: "2-digit"
			};
			fileName = new Date().toLocaleTimeString("de-DE", options);
		}
		this.props.createFileNode(payload, nodeType, file, { title: fileName }, (newNode) => {
			this.setState({
				...this.state,
				scrollToItem: newNode.$id
			});
		});
	};

	deleteNodeFromPayload = node => this.props.deleteNode(node);

	changeNodeProperty = (node, property) => this.props.changeNodeProperty(node, property);

	componentDidUpdate() {
		const { scrollToItem } = this.state;

		/* once node has finished uploading, scroll to it after finishing rendering */
		if (!this.props.nodeHandler.isUploading && scrollToItem) {
			const el = document.getElementById(scrollToItem);
			if (el) {
				document.getElementById(scrollToItem).scrollIntoView();
				window.scrollBy(0, -100); // Adjust scrolling with a negative value here
				this.setState({...this.state, scrollToItem: null});
			}
		}
	}

	/*componentWillUnmount() {
		this.props.resetNodeHandler(); // important after upload, otherwise some fields are still filled
	}*/

	render() {
		const { selectFile, addNodeAndFileToPayload } = this;
		const { addNodeToPayload, deleteNodeFromPayload, changeNodeProperty } = this;
		const { scrollToItem } = this.state;
		const { bundle, user, payload, children, nodeHandler, addToast } = this.props;
		const { isUploading, uploadStatus, error } = nodeHandler;

		const childProps = {
			user,
			bundle,
			payload,
			scrollToItem,
			actionHandler: {
				nodeHandler,
				selectFile,
				addNodeToPayload,
				addNodeAndFileToPayload,
				deleteNodeFromPayload,
				changeNodeProperty,
				addToast
			},
		};

		const renderUpload = () =>	<UploadProgress id="fileUploadProgress" title={"Datei wird hochgeladen..."} value={uploadStatus} />;

		const renderError = () => <div className="error">{error.message}</div>;

		return (
			<div className="bundle-payload-container">
				<div className="bundle-payload-container-header">
					<FileSelector ref={c => this.fileSelector = c} onFileSelected={this.addNodeAndFileToPayload}/>
					{ isUploading && !error && renderUpload() }
					{ error && renderError() }
				</div>
				<div className="bundle-payload-container-body">
					{ childProps && React.Children.map(children, (child => React.cloneElement(child, childProps))) }
				</div>
			</div>
		);
	}
}

export default connect(
  (state, ownProps) => ({
      user: ownProps.user,
      payload: _.get(ownProps, 'bundle.payload'),
      nodeHandler: state.nodeHandler,
	}),
	{...dispatchBundleActions, ...dispatchNodeActions}
)(PayloadContainer);



// WEBPACK FOOTER //
// ./src/components/bundle/containers/PayloadContainer.jsx